import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-aeps',
    templateUrl: './aeps.component.html',
    styleUrls: ['./aeps.component.scss']
})
export class AEPSComponent implements OnInit {

    constructor(
        public router: Router
    ) { }

    ngOnInit() {}

}